(function () {
  var STORAGE_KEY = 'hb_cookie_consent';
  var CATEGORIES = ['analytics', 'marketing', 'preferences'];

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function readStoredConsent() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (
        typeof parsed === 'object' &&
        parsed &&
        typeof parsed.analytics === 'boolean' &&
        typeof parsed.marketing === 'boolean' &&
        typeof parsed.preferences === 'boolean'
      ) {
        return parsed;
      }
      return null;
    } catch (e) {
      return null;
    }
  }

  function writeStoredConsent(consent) {
    try {
      window.localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          analytics: !!consent.analytics,
          marketing: !!consent.marketing,
          preferences: !!consent.preferences,
          ts: Date.now()
        })
      );
    } catch (e) {
      // localStorage unavailable (private mode, blocked storage) — nothing to persist.
    }
  }

  // Shopify's own record of the visitor's choice. Shopify stores it in its
  // own (HttpOnly) cookies, so it's invisible to document.cookie but is what
  // checkout and the Google & YouTube app read. Returns null until the visitor
  // has actually decided: every category must be an explicit "yes"/"no" —
  // a partial answer (e.g. only marketing pre-declined by a Global Privacy
  // Control signal) is not a decision, and the banner must still be shown.
  function readShopifyConsent() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || typeof cp.currentVisitorConsent !== 'function') return null;
    var current = cp.currentVisitorConsent() || {};
    var decided = CATEGORIES.every(function (key) {
      return current[key] === 'yes' || current[key] === 'no';
    });
    if (!decided) return null;
    return {
      analytics: current.analytics === 'yes',
      marketing: current.marketing === 'yes',
      preferences: current.preferences === 'yes'
    };
  }

  function sameConsent(a, b) {
    if (!a || !b) return false;
    return CATEGORIES.every(function (key) {
      return !!a[key] === !!b[key];
    });
  }

  function applyToShopify(consent, cb) {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || typeof cp.setTrackingConsent !== 'function') {
      if (cb) cb();
      return;
    }
    cp.setTrackingConsent(
      {
        analytics: consent.analytics,
        marketing: consent.marketing,
        preferences: consent.preferences,
        sale_of_data: consent.marketing
      },
      function (err) {
        // Shopify calls back with null on success and { error: '...' } on failure.
        if (err) console.warn('[hb-cookie] setTrackingConsent failed:', err.error || err);
        if (cb) cb();
      }
    );
  }

  ready(function () {
    var banner = document.getElementById('hb-cookie-banner');
    var panel = document.getElementById('hb-cookie-settings');
    if (!banner || !panel) return;

    var toggles = {
      preferences: document.getElementById('hb-cookie-toggle-preferences'),
      analytics: document.getElementById('hb-cookie-toggle-analytics'),
      marketing: document.getElementById('hb-cookie-toggle-marketing')
    };

    var lastFocused = null;

    function setToggle(el, on) {
      if (!el) return;
      el.setAttribute('aria-checked', on ? 'true' : 'false');
    }

    function toggleIsOn(el) {
      return !!el && el.getAttribute('aria-checked') === 'true';
    }

    Object.keys(toggles).forEach(function (key) {
      var el = toggles[key];
      if (!el) return;
      el.addEventListener('click', function () {
        setToggle(el, !toggleIsOn(el));
      });
    });

    function showBanner() {
      banner.hidden = false;
      window.requestAnimationFrame(function () {
        banner.classList.add('is-visible');
      });
    }

    function hideBanner() {
      banner.classList.remove('is-visible');
      banner.hidden = true;
    }

    function getFocusable(container) {
      return container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
    }

    function onPanelKeydown(e) {
      if (e.key === 'Escape') {
        closeSettings();
        return;
      }
      if (e.key === 'Tab') {
        var focusable = getFocusable(panel);
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    function openSettings(prefill) {
      lastFocused = document.activeElement;

      if (prefill) {
        var current = readShopifyConsent() || readStoredConsent();
        if (current) {
          setToggle(toggles.preferences, current.preferences);
          setToggle(toggles.analytics, current.analytics);
          setToggle(toggles.marketing, current.marketing);
        }
      }

      panel.hidden = false;
      document.addEventListener('keydown', onPanelKeydown);
      var focusable = getFocusable(panel);
      if (focusable.length) focusable[0].focus();
    }

    function closeSettings() {
      panel.hidden = true;
      document.removeEventListener('keydown', onPanelKeydown);
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    function saveConsent(consent, cb) {
      // Shopify's own consent storage is the source of truth (checkout and the
      // Google & YouTube app read it). localStorage is only a backup, used to
      // restore the choice if Shopify's cookies are cleared.
      writeStoredConsent(consent);
      applyToShopify(consent, cb);
    }

    var acceptAllBtn = banner.querySelector('[data-hb-cookie-accept-all]');
    if (acceptAllBtn) {
      acceptAllBtn.addEventListener('click', function () {
        saveConsent({ analytics: true, marketing: true, preferences: true }, hideBanner);
      });
    }

    var necessaryOnlyBtn = banner.querySelector('[data-hb-cookie-necessary-only]');
    if (necessaryOnlyBtn) {
      necessaryOnlyBtn.addEventListener('click', function () {
        saveConsent({ analytics: false, marketing: false, preferences: false }, hideBanner);
      });
    }

    var openSettingsBtn = banner.querySelector('[data-hb-cookie-open-settings]');
    if (openSettingsBtn) {
      openSettingsBtn.addEventListener('click', function () {
        openSettings(false);
      });
    }

    // Any element on the page (e.g. the footer link) can reopen the panel
    // with the visitor's current choices pre-filled.
    document.querySelectorAll('[data-hb-cookie-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        hideBanner();
        openSettings(true);
      });
    });

    var saveBtn = panel.querySelector('[data-hb-cookie-save]');
    if (saveBtn) {
      saveBtn.addEventListener('click', function () {
        saveConsent(
          {
            analytics: toggleIsOn(toggles.analytics),
            marketing: toggleIsOn(toggles.marketing),
            preferences: toggleIsOn(toggles.preferences)
          },
          function () {
            closeSettings();
            hideBanner();
          }
        );
      });
    }

    var acceptAllSettingsBtn = panel.querySelector('[data-hb-cookie-accept-all-settings]');
    if (acceptAllSettingsBtn) {
      acceptAllSettingsBtn.addEventListener('click', function () {
        setToggle(toggles.preferences, true);
        setToggle(toggles.analytics, true);
        setToggle(toggles.marketing, true);
        saveConsent({ analytics: true, marketing: true, preferences: true }, function () {
          closeSettings();
          hideBanner();
        });
      });
    }

    var closeBtn = panel.querySelector('[data-hb-cookie-close]');
    if (closeBtn) closeBtn.addEventListener('click', closeSettings);

    var backdrop = panel.querySelector('[data-hb-cookie-backdrop]');
    if (backdrop) backdrop.addEventListener('click', closeSettings);

    function init() {
      if (!(window.Shopify && window.Shopify.loadFeatures)) return;
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        if (err) {
          console.warn('[hb-cookie] consent-tracking-api failed to load:', err);
          return;
        }

        var shopifyChoice = readShopifyConsent();
        if (shopifyChoice) {
          // Visitor has already decided and Shopify remembers it: don't show the
          // banner, and keep the localStorage backup in step with it.
          if (!sameConsent(readStoredConsent(), shopifyChoice)) writeStoredConsent(shopifyChoice);
          return;
        }

        var stored = readStoredConsent();
        if (stored) {
          // Decided on an earlier visit but Shopify no longer has it (cookies
          // cleared or expired): restore it into Shopify, don't ask again.
          applyToShopify(stored);
          return;
        }

        if (window.Shopify.customerPrivacy.shouldShowBanner()) showBanner();
      });
    }

    init();
  });
})();
